import { useEffect, useMemo, useState } from "react";
import { useForm } from "../../../hooks";
import {
  ErrorMessage,
  LoadingData,
  SelectForm as Select,
  InputForm as Input,
  MainButton,
} from "../../ui";
import {
  useFormMessages,
  usePatientSurgeryStore,
  useFormEventStore,
  useSelectOptionsStore,
  useScheduleStore,
} from "../../hooks";

const initialFormData = {
  surgeryRoomId: "",
};

const formValidations = {
  surgeryRoomId: [
    (value) => value.length > 0,
    "Selecciona una sala de prcedimiento",
  ],
};

const autoSurgeryConfig = [
  {
    procedureId: "d110d833-b4d2-11ef-a5cd-066d180a3717",
    ipsId: "8d47ae32-912a-476f-929a-9d0d73ed3b9c",
    surgeryRoomId: "1d9ece0e-1179-4698-832c-19aea067b19b",
  },
  // otras configuraciones...
];

export const ProcedureFilterForm = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,
  } = usePatientSurgeryStore();

  const {
    // Props
    isLoading,
    message,
  } = useFormEventStore();

  const {
    // Props
    surgeryRooms,

    // Methods
    getSurgeryRoomsByIpsId,
  } = useSelectOptionsStore();

  const {
    // Methods
    startGetScheduleBySurgeryRoomId,
  } = useScheduleStore();

  const { patient, procedure, numberEvents } = patientSurgery.data;
  const { user } = patient;

  const matchedConfig = useMemo(() => {
    return autoSurgeryConfig.find(
      (config) =>
        config.procedureId === procedure.procedure.id &&
        config.ipsId === user.ips.id
    );
  }, [procedure.procedure.id, user.ips.id]);

  // States ------------------------------------------------//
  const [formData, setFormData] = useState(initialFormData);
  const [validateForm, setValidateForm] = useState(false);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    formData,
    formValidations
  );

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
  });

  // Funciones ---------------------------------------------//
  const handleSubmit = () => {
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startGetScheduleBySurgeryRoomId(formState);
    }
  };

  const handleProgrammaticSubmit = ({ formState }) => {
    setFormSubmitted(true);
    startGetScheduleBySurgeryRoomId(formState);
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (surgeryRooms.data.length === 0 && surgeryRooms.message === null) {
      getSurgeryRoomsByIpsId({ ipsId: user.ips.id });
    }
  }, [surgeryRooms.data, getSurgeryRoomsByIpsId, user.ips.id]);

  useEffect(() => {
    if (surgeryRooms.data.length === 0) return;
    if (!matchedConfig) return;

    const newFormState = {
      ...formState,
      surgeryRoomId: matchedConfig.surgeryRoomId,
    };

    setFormData(newFormState);
    handleProgrammaticSubmit({ formState: newFormState });
  }, [surgeryRooms.data, matchedConfig]);

  useEffect(() => {
    if (showSuccessMessage) {
      setFormSubmitted(false);
    }
  }, [showSuccessMessage]);

  // useEffect(() => {
  //   console.log("formState", formState);
  // }, [formState]);

  // useEffect(() => {
  //   console.log("formValidation", formValidation);
  // }, [formValidation]);

  return (
    <>
      <div className="card border">
        <div className="card-body">
          <div className="row gy-3">
            <div className="col-12">
              <h5 className="mb-0">Agenda tu procedimiento</h5>
            </div>
            <div className="col-12">
              <Input
                label={`IPS`}
                name="ips"
                value={`${user.ips.name}`}
                onInputChange={() => {}}
                disabled={true}
              />
            </div>
            <div className="col-12">
              <Select
                label={"Sala de procedimiento y sede"}
                options={surgeryRooms.data}
                labelKey={"name"}
                validation={formValidation.surgeryRoomIdValid}
                submit={validateForm}
                name={"surgeryRoomId"}
                value={formState.surgeryRoomId}
                onInputChange={onInputChange}
                disabled={!!matchedConfig}
              />
            </div>
            {numberEvents !== null && (
              <div className="col-12">
                <Input
                  label={`Sesiones para agendar`}
                  name="numberEvents"
                  value={numberEvents}
                  onInputChange={() => {}}
                  disabled={true}
                />
              </div>
            )}
            <div className="col-12">
              <MainButton
                type="button"
                onClick={() => {
                  handleSubmit();
                }}
                disabled={isLoading}
              >
                Buscar
              </MainButton>
            </div>

            {/* Mensajes */}
            {(surgeryRooms.isLoading || isLoading) && (
              <div className="col-12">
                <LoadingData />
              </div>
            )}

            {showErrorMessage && (
              <div className="col-12">
                <ErrorMessage>{messageText}</ErrorMessage>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
